import { effect, signal } from "@preact/signals-react";
import { NavLink, useNavigate } from "react-router-dom";
import { getUserRoleFromToken, isTokenExpired } from "../../../../utils/auth";
import useAuthRequest from "../../../../utils/useAuthRequest";
import "../styles/OttoStyles.css";
import OrderCard from "../../../components/cards/OrderCard";
import { useOrders } from "../../../helper/OrderContext";

type Dimension = {
	displayName: string;
	type: string;
	value: string;
};

type Product = {
	title: string;
	salesPrice: string;
	articleNumber: string;
	ean: string;
};

type Order = {
	id: string;
	orderNumber: string;
	orderDate: string;
	products: Product[];
	fulfillmentStatus?: string;
};

export default function OrderPickPage() {
	const sendRequest = useAuthRequest();
	const navigate = useNavigate();
	const token = localStorage.getItem("authToken");
	const userRole = getUserRoleFromToken();
	const { ordersPick, fetchOrders } = useOrders();

	effect(() => {
		if (
			!token ||
			!userRole ||
			isTokenExpired(token) ||
			userRole !== "bucher"
		) {
			navigate("/login");
		}
		fetchOrders("pending");
		const intervalId = setInterval(() => {
			fetchOrders("pending");
		}, 1000);

		// Cleanup-Funktion
		return () => clearInterval(intervalId);
	});

	const handlePackOrder = async (orderId: string) => {
		try {
			const response = await sendRequest<{ status: string }>(
				`/api/otto/orders/${orderId}/status`,
				"patch",
				{ status: "picked" }
			);
			if (response.status === 200) {
				fetchOrders("pending");
				fetchOrders("picked");
				fetchOrders("packed");
				fetchOrders("shipped");
			} else {
				throw new Error("Fehler beim Aktualisieren des Bestellstatus");
			}
		} catch (error) {
			console.error(
				"Fehler beim Aktualisieren des Bestellstatus:",
				error
			);
		}
	};

	return (
		<>
			<div className="text-gray-900 dark:text-gray-50 flex flex-col gap-4 p-6">
				{ordersPick.length > 0 ? (
					ordersPick.map((order) => (
						<OrderCard
							key={order.id}
							order={order}
							onPackOrder={handlePackOrder}
						/>
					))
				) : (
					<div className="flex flex-col items-start justify-start bg-gray-300 dark:bg-sidebarGray-700 rounded-lg p-6">
						<h1 className="font-bold text-3xl">
							Es wurde keine Bestellungen gefunden.
						</h1>
					</div>
				)}
			</div>
		</>
	);
}
